import fetchOrder from '../Services/fetchOrder';

export default () => async (dispatch) => {

  console.log('[OrderView] didUpdateOrder - refetching order...');
  await dispatch(fetchOrder());
  console.log('[OrderView] didUpdateOrder - order refetched');

}
